import React, { useState } from "react";

import { TextInput, TextInputProps } from "components/TextInput/TextInput";

interface TextInputWithValidationProps extends TextInputProps {
  setValue: (value: string) => void;
  value: string;
  isValueValid: (isValid: boolean) => void;
  displayErrors: boolean;
  additionalValidation?: (newValue: string) => string;
  dataTestId?: string;
}

const TextInputWithValidation: React.FC<TextInputWithValidationProps> = ({
  id,
  inputName,
  setValue,
  value,
  isValueValid,
  displayErrors,
  type,
  minLength,
  maxLength,
  label,
  placeholder,
  disabled,
  additionalValidation,
  dataTestId,
}) => {
  const getError = (input: string): string => {
    if (!input) {
      if (typeof label === "string")
        return "Please enter a " + label.toLowerCase();
      return "This is a required field";
    }

    if (minLength && input.length < minLength) {
      return `Minimum length is ${minLength} chars`;
    }

    if (maxLength && input.length >= maxLength) {
      return `Maximum length is ${maxLength} chars`;
    }

    if (additionalValidation) {
      return additionalValidation(input);
    }
    return "";
  };

  const [valueError, setValueError] = useState(getError(value));

  const valueUpdate: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    const newValue = event.target.value;
    setValue(newValue);
    const newValueError = getError(newValue);
    setValueError(newValueError);
    isValueValid(newValueError?.length === 0);
  };

  return (
    <TextInput
      id={id}
      inputName={inputName}
      label={label}
      onChange={valueUpdate}
      value={value}
      type={type}
      error={displayErrors && valueError.length > 0}
      errorMessage={valueError}
      placeholder={placeholder}
      disabled={disabled}
      data-testid={dataTestId}
    />
  );
};

export default TextInputWithValidation;
